export enum CtaLayout1Theme {
  CREAM = 'CREAM',
  RED = 'RED',
  WHITE = 'WHITE',
}
